import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MedicalServicesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"medical_services"}/>
}
